<div class="create-flow-footer">
  <ng-content></ng-content>
</div>
